import { AuthContextType } from './../components/AuthContextWrapper';
import { useContext, createContext } from 'react';
export const AuthContext = createContext(null);

export default function useAuthContext(): AuthContextType | null {
  return useContext(AuthContext);
}
